import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import Button from 'UIKit/Button'
import Text from 'UIKit/Text'
import useModal from 'hooks/useModal'
import { Trans } from 'react-i18next'
import { useAuth } from 'state/auth/hooks'
import styled from 'styled-components'
import Payment from 'views/Payment'
import { PaymentPageEnums } from 'views/Payment/Menu'

const PaymentButton: React.FC<BoxProps> = ({ ...props }) => {
  const [handlePresentModal] = useModal(Payment)
  const { hasSession } = useAuth()

  return (
    hasSession && (
      <StyledWrapper alignItems="center" {...props}>
        <StyledPaymentButton onClick={() => handlePresentModal({ defaultPage: PaymentPageEnums.Deposit })}>
          <Text fontSize="14px" fontWeight="600" lineHeight="normal" letterSpacing={-0.28}>
            <Trans>Deposit</Trans>
          </Text>
        </StyledPaymentButton>
      </StyledWrapper>
    )
  )
}

const StyledWrapper = styled(Flex)``

const StyledPaymentButton = styled(Button)`
  border-radius: ${({ theme: { radii } }) => radii.tiny};
  height: 36px;
`

export default PaymentButton
